import projectsData from "../data/projects.json";

export const SITE_TITLE = "Mohammed Sagban";

const STATIC_PAGE_TITLES: Record<string, string> = {
  "/contact": "Contact",
  "/experience": "Experience",
  "/projects": "Projects",
  "/now": "Now",
  "/blog": "Blog",
  "/resume": "Resume",
  "/404": "Page not found",
};

type ProjectJson = { slug: string; title: string; hasDetailPage?: boolean };

const projectTitleBySlug: Record<string, string> = {};
for (const p of projectsData as ProjectJson[]) {
  if (p.hasDetailPage === false) continue;
  if (p.slug) projectTitleBySlug[p.slug] = p.title;
}

function normalizePath(pathname: string): string {
  return (pathname || "/").replace(/\/$/, "") || "/";
}

/** Client-side document title (matches PageHead: `page | SITE_TITLE`). */
export function getDocumentTitle(pathname: string): string {
  const p = normalizePath(pathname);
  if (p === "/") {
    return `${SITE_TITLE} — Software Engineer & Pharmacist`;
  }
  const staticTitle = STATIC_PAGE_TITLES[p];
  if (staticTitle) return `${staticTitle} | ${SITE_TITLE}`;

  const projectMatch = /^\/projects\/([^/]+)$/.exec(p);
  if (projectMatch) {
    const slug = projectMatch[1];
    const title = projectTitleBySlug[slug];
    if (title) return `${title} | ${SITE_TITLE}`;
  }

  return SITE_TITLE;
}
